// Stability: error rate + edge function failures across the stack.
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Card, CardContent } from "@/components/ui/card";
import { ErrorsCard } from "@/components/admin/ErrorsCard";
import { Loader2 } from "lucide-react";
import type { UsageRow } from "@/hooks/useAdminMetrics";

export default function AdminStability() {
  const [usage, setUsage] = useState<UsageRow[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    (async () => {
      setLoading(true);
      const since = new Date(Date.now() - 30 * 86400_000).toISOString();
      const { data } = await supabase
        .from("gemini_usage")
        .select("id,user_id,model,call_type,input_tokens,output_tokens,estimated_cost_usd,status,error,created_at")
        .gte("created_at", since)
        .order("created_at", { ascending: false })
        .limit(5000);
      if (!active) return;
      setUsage((data ?? []) as UsageRow[]);
      setLoading(false);
    })();
    return () => {
      active = false;
    };
  }, []);

  if (loading) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-7xl space-y-6 p-4">
      <div>
        <h1 className="font-display text-2xl font-bold tracking-tight">Stability</h1>
        <p className="text-sm text-muted-foreground">AI call success and recent errors (last 30 days).</p>
      </div>

      <ErrorsCard usage={usage} />

      <Card>
        <CardContent className="p-4 text-xs text-muted-foreground">
          Edge-function 5xx tracking and ANR/crash trends will land here in the next iteration — they
          require an aggregation edge function over the analytics logs.
        </CardContent>
      </Card>
    </div>
  );
}
